import React from "react";

export default function SQLServer_SOUNDEX() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SOUNDEX</h1>
      <p>This is the SQLServer_SOUNDEX component generated from the SQL JSON.</p>
    </div>
  );
}
